(function(){
  /* Frosted cream glass seen from below; a giant cat walks across it. Where a paw presses the glass it turns sharp.
     Mouse: the paws follow in a real gait. Touch or idle: the cat walks across by itself. */
  var box=document.getElementById('glassHero'); if(!box) return;
  var cv=box.querySelector('canvas'), ctx=cv.getContext('2d');
  var reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
  var W,H,D,frost=null,prints=[],shadow={x:0,y:0,tx:0,ty:0},last=null,dist=0,side=1,lastInput=0,auto=null,visible=true,running=false;
  function size(){
    var r=box.getBoundingClientRect(); D=Math.min(1.5,window.devicePixelRatio||1);
    W=cv.width=Math.round(r.width*D); H=cv.height=Math.round(r.height*D); buildFrost();
    shadow.x=shadow.tx=W*.5; shadow.y=shadow.ty=H*.45;
    if(reduce){ prints=[]; [[.28,.62,-.3],[.4,.48,-.3],[.52,.6,-.3],[.64,.44,-.3]].forEach(function(p,i){ prints.push({x:p[0]*W,y:p[1]*H,a:p[2],t:performance.now()-900,s:i%2?1:-1,st:true}); }); draw(performance.now()); }
  }
  function buildFrost(){
    frost=document.createElement('canvas'); frost.width=W; frost.height=H; var g=frost.getContext('2d');
    // what's above the glass: warm light from one side, falling off. Cream throughout.
    var bg=g.createLinearGradient(0,0,W,H); bg.addColorStop(0,'#faf5e9'); bg.addColorStop(.55,'#f1e8d5'); bg.addColorStop(1,'#d7caaf'); g.fillStyle=bg; g.fillRect(0,0,W,H);
    var lamp=g.createRadialGradient(W*.22,H*.15,0,W*.22,H*.15,Math.max(W,H)*.7); lamp.addColorStop(0,'rgba(255,250,236,.45)'); lamp.addColorStop(1,'rgba(255,250,236,0)'); g.fillStyle=lamp; g.fillRect(0,0,W,H);
    // the frosting: fine grain
    var img=g.getImageData(0,0,W,H), d=img.data; for(var i=0;i<d.length;i+=4){ var n=(Math.random()-.5)*16; d[i]+=n; d[i+1]+=n; d[i+2]+=n; } g.putImageData(img,0,0);
    // a soft sheen across the pane
    var sh=g.createLinearGradient(0,0,W,H*.6); sh.addColorStop(0,'rgba(255,255,255,0)'); sh.addColorStop(.48,'rgba(255,255,255,.12)'); sh.addColorStop(.52,'rgba(255,255,255,.03)'); sh.addColorStop(1,'rgba(255,255,255,0)'); g.fillStyle=sh; g.fillRect(0,0,W,H);
  }
  function paw(x,y,ang,k,a,flat){
    // k = size, a = opacity (pressure), flat = how squashed against the glass (1 = fully pressed)
    ctx.save(); ctx.translate(x,y); ctx.rotate(ang); ctx.scale(k*(1+.04*flat),k*(1+.06*flat));
    // the rest of the paw and fur just above the glass: dark and blurred
    function soft(cx,cy,rx,ry,al){ ctx.save(); ctx.translate(cx,cy); ctx.scale(rx/60,ry/60); var f=ctx.createRadialGradient(0,0,0,0,0,60); f.addColorStop(0,'rgba(58,40,33,'+al+')'); f.addColorStop(.55,'rgba(58,40,33,'+(al*.5)+')'); f.addColorStop(1,'rgba(58,40,33,0)'); ctx.fillStyle=f; ctx.fillRect(-60,-60,120,120); ctx.restore(); }
    soft(0,34,40,70,.22*a);   // the leg, further from the glass, blurrier
    soft(0,-2,44,48,.5*a);    // the paw's fur, just above the glass
    // the clear ring where the glass is touched
    soft(0,-2,32,34,.16*a*flat);
    function bean(bx,by,rx,ry,rot){ var gr=ctx.createRadialGradient(bx-rx*.3,by-ry*.35,1,bx,by,Math.max(rx,ry)); gr.addColorStop(0,'rgba(214,160,152,'+a+')'); gr.addColorStop(.75,'rgba(180,126,119,'+a+')'); gr.addColorStop(1,'rgba(128,84,78,'+a+')');
      ctx.fillStyle=gr; ctx.beginPath(); ctx.ellipse(bx,by,rx,ry,rot,0,6.283); ctx.fill();
      ctx.fillStyle='rgba(255,255,255,'+(.12*a*flat)+')'; ctx.beginPath(); ctx.ellipse(bx-rx*.3,by-ry*.35,rx*.25,ry*.15,rot,0,6.283); ctx.fill(); }
    // main pad: three lobes
    var mp=ctx.createRadialGradient(-3,4,2,0,10,24); mp.addColorStop(0,'rgba(214,160,152,'+a+')'); mp.addColorStop(.75,'rgba(180,126,119,'+a+')'); mp.addColorStop(1,'rgba(128,84,78,'+a+')');
    ctx.fillStyle=mp; ctx.beginPath(); ctx.moveTo(-15,1); ctx.bezierCurveTo(-12,-9,12,-9,15,1); ctx.bezierCurveTo(21,8,22,19,13,21);
    ctx.bezierCurveTo(9,22,7,19,5,20); ctx.bezierCurveTo(3,24,-3,24,-5,20); ctx.bezierCurveTo(-7,19,-9,22,-13,21); ctx.bezierCurveTo(-22,19,-21,8,-15,1); ctx.closePath(); ctx.fill();
    ctx.fillStyle='rgba(255,255,255,'+(.12*a*flat)+')'; ctx.beginPath(); ctx.ellipse(-5,2,6,2.5,-.2,0,6.283); ctx.fill();
    // four toe beans
    bean(-19,-12,6.5,8,-.45); bean(-7,-22,6.5,8.5,-.12); bean(7,-22,6.5,8.5,.12); bean(19,-12,6.5,8,.45);
    ctx.restore();
  }
  function mark(x,y,ang,k,a){ // the print a warm paw leaves on cold cream glass: a touch deeper than the pane
    ctx.save(); ctx.translate(x,y); ctx.rotate(ang); ctx.scale(k,k); ctx.fillStyle='rgba(146,110,84,'+(a*.6)+')';
    ctx.beginPath(); ctx.moveTo(-15,1); ctx.bezierCurveTo(-12,-9,12,-9,15,1); ctx.bezierCurveTo(21,8,22,19,13,21); ctx.bezierCurveTo(9,22,7,19,5,20); ctx.bezierCurveTo(3,24,-3,24,-5,20); ctx.bezierCurveTo(-7,19,-9,22,-13,21); ctx.bezierCurveTo(-22,19,-21,8,-15,1); ctx.closePath(); ctx.fill();
    [[-19,-12,7,9,-.45],[-7,-22,7,9.5,-.12],[7,-22,7,9.5,.12],[19,-12,7,9,.45]].forEach(function(b){ ctx.beginPath(); ctx.ellipse(b[0],b[1],b[2],b[3],b[4],0,6.283); ctx.fill(); });
    ctx.restore(); }
  function step(x,y,ang){
    // place a print beside the line of travel, alternating left and right
    var off=46*D*(W>900*D?1.25:.8)*side; side=-side;
    prints.push({x:x+Math.cos(ang+Math.PI/2)*off, y:y+Math.sin(ang+Math.PI/2)*off, a:ang+Math.PI/2, t:performance.now(), s:side});
    if(prints.length>8) prints.shift();
    shadow.tx=x; shadow.ty=y-40*D;
  }
  function move(x,y){
    if(!last){ last={x:x,y:y}; return; }
    var dx=x-last.x, dy=y-last.y, d=Math.hypot(dx,dy); if(d<1) return;
    dist+=d; var stride=170*D*(W>900*D?1.25:.8);
    if(dist>=stride){ dist=0; step(x,y,Math.atan2(dy,dx)); }
    last={x:x,y:y};
  }
  function draw(now){
    if(!frost) return;
    ctx.globalCompositeOperation='source-over'; ctx.drawImage(frost,0,0);
    // the cat's body above the glass: one big, soft shadow drifting with the walk
    shadow.x+=(shadow.tx-shadow.x)*.04; shadow.y+=(shadow.ty-shadow.y)*.04;
    var R=Math.max(W,H)*.34; ctx.save(); ctx.translate(shadow.x,shadow.y); ctx.rotate(-.15); ctx.scale(1.35,.72);
    var sg=ctx.createRadialGradient(0,0,0,0,0,R); sg.addColorStop(0,'rgba(74,44,32,.28)'); sg.addColorStop(.6,'rgba(74,44,32,.12)'); sg.addColorStop(1,'rgba(74,44,32,0)');
    ctx.fillStyle=sg; ctx.fillRect(-R,-R,2*R,2*R); ctx.restore();
    var k=(W>900*D?1.25:.8)*D*1.55;
    prints=prints.filter(function(p){ return now-p.t<5200; });
    prints.forEach(function(p){
      var t=now-p.t, a, flat;
      if(p.st){ a=1; flat=1; }
      else if(t<140){ a=t/140; flat=t/140; }             // paw coming down
      else if(t<700){ a=1; flat=1; }                     // weight on it
      else if(t<1300){ var q=(t-700)/600; a=1-q*.8; flat=1-q; } // lifting
      else { a=.2*(1-(t-1300)/3900); flat=0; }           // a faint warm mark, fading
      if(a<=0) return;
      if(t>=1300&&!p.st){ mark(p.x,p.y,p.a,k,a); return; }
      paw(p.x,p.y,p.a+Math.PI/2*0,k,a,flat);
    });
  }
  function frame(now){
    if(!visible||document.hidden){ running=false; return; }
    if(!reduce && now-lastInput>2600){ // nobody moving: the cat walks across by itself
      if(!auto) auto={x:-10*D,y:H*(.35+Math.random()*.3),t:now,ph:Math.random()*6};
      var dt=Math.min(50,now-(auto.t||now)); auto.t=now; auto.x+=W*dt/5200; var y=auto.y+Math.sin(auto.x/(W*.18)+auto.ph)*H*.06; move(auto.x,y);
      if(auto.x>W+80*D){ auto=null; last=null; }
    }
    draw(now); requestAnimationFrame(frame);
  }
  function start(){ if(!running&&visible&&!document.hidden&&!reduce){ running=true; requestAnimationFrame(frame); } }
  function pt(e){ var r=cv.getBoundingClientRect(); return {x:(e.clientX-r.left)*W/r.width, y:(e.clientY-r.top)*H/r.height}; }
  box.addEventListener('pointermove',function(e){ if(reduce) return; lastInput=performance.now(); if(auto){ auto=null; last=null; } var p=pt(e); move(p.x,p.y); });
  box.addEventListener('pointerleave',function(){ last=null; });
  size(); var rt; addEventListener('resize',function(){ clearTimeout(rt); rt=setTimeout(size,150); });
  if('IntersectionObserver' in window) new IntersectionObserver(function(es){ visible=es[0].isIntersecting; start(); }).observe(box); else start();
  document.addEventListener('visibilitychange',start);
  window.__glassMove=function(x,y){ lastInput=performance.now(); auto=null; move(x*D,y*D); };
})();
